import React, { useState } from "react";
import Axios from '../../utils/Axios';

const UNIVERSITIES = ["NUS", "NTU", "SMU", "SUTD", "SUSS", "SIT"];

export default function TrendsPage() {
  const [university, setUniversity] = useState("");
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const fetchTrends = async () => {
    if (!university) {
      setError("Please select a university.");
      return;
    }
    setError("");
    setLoading(true);
    try {
      const res = await Axios.get(`/api/user/trends/${university}`);
      setReviews(res.data);
    } catch (err) {
      setError("Failed to fetch trends.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <h1>Movie trends in your university: Select your university</h1>
      <select
        value={university}
        onChange={(e) => setUniversity(e.target.value)}
      >
        <option value="">Select your university</option>
        {UNIVERSITIES.map((uni) => (
          <option key={uni} value={uni}>
            {uni}
          </option>
        ))}
      </select>
      <button onClick={fetchTrends} style={{ marginLeft: 10 }}>
        View Trends
      </button>

      {error && <p style={{ color: "red" }}>{error}</p>}
      {loading && <p>Loading...</p>}

      <div style={{ marginTop: 20 }}>
        {reviews.length === 0 && !loading && <p>No reviews found.</p>}

        {reviews.map((review) => (
          <div
            key={review._id}
            style={{
              border: "1px solid #ccc",
              borderRadius: 8,
              padding: 10,
              marginBottom: 10,
            }}
          >
            <h3>{review.movieTitle}</h3>
            <p>Rating: {review.rating} / 5</p>
            <p>{review.review}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
